import WebViewer from '@pdftron/pdfjs-express-viewer';

export default class PdfViewer {

    static initializeEvents() {
        Array.from(document.querySelectorAll('[data-pdf-viewer-url]:not([data-loaded])')).forEach(viewer => {
            if (PdfViewer.isVisible(viewer)) {
                PdfViewer.renderViewer(viewer);
            }
        });
    }

    static isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    static renderViewer(viewerElement) {
        const disabledElements = [
            'ribbons',
            'viewControlsButton',
            'toggleNotesButton',
            'printButton',
            'languageButton',
            'themeChangeButton',
            'textSelectButton',
            'toolsHeader',
            'textHighlightToolButton',
            'textUnderlineToolButton',
            'textSquigglyToolButton',
            'textStrikeoutToolButton',
            'linkButton',
            'menuButton',
            'contextMenuPopup',
        ];

        if (viewerElement.hasAttribute('data-pdf-viewer-light')) {
            disabledElements.push('leftPanelButton', 'searchButton');
        }

        let licenseKey = '8lnfX80oHPKr5lC2WJHR';
        if (window.location.hostname.includes('onisep-preprod.fr')) {
            licenseKey = 'k48Uy80qlsBmPbxc7uzn';
        }

        WebViewer({
            licenseKey,
            path: '/assets/onisep/build/bundles/pdfjsexpress',
            initialDoc: viewerElement.dataset.pdfViewerUrl,
            css: '/assets/onisep/build/pdf_viewer.css',
            accessibleMode: true,
            disabledElements
        }, viewerElement).then(instance => {
            instance.Core.documentViewer.setMargin(0);
            instance.Core.documentViewer.addEventListener('documentLoaded', async () => {
                const bookmarks = await instance.Core.documentViewer.getDocument().getBookmarks();
                if (bookmarks[0] !== undefined) {
                    instance.UI.enableElements(['outlinesPanelButton']);
                    this.updateViewerIcon(instance, 'outlinesPanelButton', 'ri-list-unordered');
                } else {
                    instance.UI.disableElements(['thumbnailsPanelButton', 'outlinesPanelButton']);
                }
            });

            if (viewerElement.dataset.pdfViewerPrintAllowed !== 'yes') {
                instance.UI.disableFeatures([instance.UI.Feature.Print]);
            }

            if (window.innerWidth > 576) {
                instance.UI.setLayoutMode(instance.UI.LayoutMode.FacingCover);
            }

            instance.UI.setFitMode(
                window.innerWidth <= 576
                    ? instance.UI.FitMode.FitWidth
                    : instance.UI.FitMode.FitPage
            );

            instance.UI.setLanguage('fr');
            instance.UI.setMaxZoomLevel(2);
            instance.UI.setHeaderItems(header => {
                if (viewerElement.hasAttribute('data-pdf-viewer-light')) {
                    header.getHeader('default').push({
                        img: '<svg class="IconBlue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><use href="/assets/icons/remixicon.svg#ri-fullscreen-line"></use></svg>',
                        index: -1,
                        type: 'actionButton',
                        element: 'fullScreenButton',
                        onClick: () => instance.UI.toggleFullScreen(),
                    });
                } else {
                    header.getHeader('default').unshift({
                        type: 'customElement',
                        render: function () {
                            const header = document.createElement('div');
                            header.classList.add('CustomHeader');

                            const logo = document.createElement('img');
                            logo.src = '/assets/dso/images/onisep/logo-sticky.svg';
                            logo.style.width = '159px';
                            logo.style.height = '20px';
                            logo.style.marginLeft = '12px';
                            header.appendChild(logo);

                            if (viewerElement.dataset.pdfViewerTitle !== undefined) {
                                const text = document.createElement('p');
                                text.innerText = viewerElement.dataset.pdfViewerTitle;
                                header.appendChild(text);
                            }

                            return header;
                        }
                    }, {type: 'spacer'});

                    if (viewerElement.dataset.pdfViewerCloseUrl !== undefined) {
                        header.getHeader('default').unshift({
                            type: 'customElement',
                            render: function () {
                                const button = document.createElement('button');
                                button.classList.add('Button');
                                button.style.marginLeft = '6px';
                                button.title = viewerElement.dataset.pdfViewerCloseTitle || 'Fermer';
                                button.innerHTML = '<div class="Icon"><svg class="IconBlue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><use href="/assets/icons/remixicon.svg#ri-close-line"></use></svg></div>';
                                button.onclick = function () {
                                    window.location.href = viewerElement.dataset.pdfViewerCloseUrl;
                                }

                                return button;
                            },
                        });
                    }
                }
            });

            this.updateViewerIcon(instance, 'leftPanelButton', 'ri-layout-left-line');
            this.updateViewerIcon(instance, 'zoomInButton', 'ri-zoom-in-line');
            this.updateViewerIcon(instance, 'zoomOutButton', 'ri-zoom-out-line');
            this.updateViewerIcon(instance, 'panToolButton', 'ri-hand');
            this.updateViewerIcon(instance, 'selectToolButton', 'ri-cursor-line');
            this.updateViewerIcon(instance, 'searchButton', 'ri-search-line');
            this.updateViewerIcon(instance, 'thumbnailsPanelButton', 'ri-newspaper-line');

            // Marque ce viewer comme initialisé pour éviter une double exécution
            viewerElement.setAttribute('data-loaded', 'true');
        });
    }

    static updateViewerIcon(instance, name, icon) {
        const svg = instance.UI.iframeWindow.document.querySelector('[data-element="' + name + '"] .Icon svg');
        if (svg !== null) {
            svg.classList.add('IconBlue');
            svg.setAttribute('viewBox', '0 0 16 16');
            svg.innerHTML = '<use xlink:href="/assets/icons/remixicon.svg#' + icon + '"></use>';
        } else {
            console.warn('Missing icon: ' + name);
        }
    }

}